<mat-button-toggle-group
  class="snow-orv-toggle-container primary"
  name="snowOrvToggle"
  aria-label="map toggle"
  [ngModel]="rideType"
  i18n-aria-label
>
  <mat-button-toggle id="toggleOrv" value="orv" (click)="setMapTypeOrv()">
    @if (showIcon) {
      <svg-icon src="/assets/icons/orv.svg" alt="orv map" role="button" aria-label="orv" i18n-aria-label i18n-alt />
    }
    @if (showTitle) {
      <span i18n>Off-Road</span>
    }
  </mat-button-toggle>
  <mat-button-toggle id="toggleSnow" value="snow" (click)="setMapTypeSnow()">
    @if (showIcon) {
      <svg-icon src="/assets/icons/snow.svg" alt="snow map" role="button" aria-label="snow" i18n-aria-label i18n-alt />
    }
    @if (showTitle) {
      <span i18n>Snow</span>
    }
  </mat-button-toggle>
</mat-button-toggle-group>
